import { useCallback, useMemo } from "react";

import { parseISO } from "date-fns";

import { useQuery } from "hooks";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

export function useQueryClientRecentMeetings(clientId) {
  const memoizedClientId = useMemo(() => {
    return clientId;
  }, [clientId]);

  const queryFactory = useCallback(() => {
    const query = `fragment ClientMeeting on Event {
                    id
                    name
                    startDate
                    endDate
                    crmState
                    meetingDateTypeId {
                      id
                      name
                    }
                    attendees {
                      edges {
                          node {
                          id
                          name
                          }
                      }
                    }
                }
                
                query getClientRecentMeetings($clientId: ID!) {
                    client(id: $clientId) {
                        nextEvent {
                            ...ClientMeeting
                            }
                        lastEvent {
                            ...ClientMeeting
                        }
                    }
                }`;

    const resolver = ({ data }) => {
      const formatNode = (node) => {
        return node
          ? {
              ...node,
              clientId: memoizedClientId,
              startDate: parseISO(node.startDate),
              endDate: parseISO(node.endDate),
              type: node.meetingDateTypeId,
              attendees: node.attendees.edges.map(({ node: attendeeNode }) => {
                return attendeeNode;
              }),
            }
          : null;
      };

      return {
        next: formatNode(data.client.nextEvent),
        last: formatNode(data.client.lastEvent),
      };
    };

    return { query, resolver };
  }, [memoizedClientId]);

  return useQuery(queryFactory, {
    variables: useMemo(() => {
      return { clientId: toGlobalId("Client", clientId) };
    }, [clientId]),
  });
}

export default useQueryClientRecentMeetings;
